import React, { useState, useEffect } from "react";
import style from "./Details.module.scss";
import PDFIcon from "../../../../assets/svg/icons/common/PDFIcon";
import useMerchantStore from "../../../../stores/merchant";
import useCommonStore from "../../../../stores/common";
import { getUploadedFiles, getAppFileData } from "../../../../../api";
import ShowDocsModal from "../../../../../components/modals/show-docs-modal/show-docs-modal";
import Spinner from "../../../../components/Loaders/Spinner";

function Documents() {
  const [documents, setDocuments] = useState([]);
  const [docModal, setDocModal] = useState(false);
  const [docModalFile, setDocModalFile] = useState(null);
  const [loading, setLoading] = useState(true);

  const activeApp = useMerchantStore((state) => state.activeApp);
  useEffect(() => {
    const fetchDocuments = async () => {
      setLoading(true);
      try {
        const response = await getUploadedFiles({ id: activeApp?.id });
        // Process the response to display documents
        if (response.status) {
          setDocuments(response.uploads);
        }
        setLoading(false);
      } catch (error) { }
    };
    fetchDocuments();
  }, [activeApp]);


  const openDocModal = async (element) => {
    if (element.id) {
      const fileToShow = ["pdf", "jpg", "jpeg", "png", "svg"];
      const fileNameParts = element.pdf_converted
        ? element.pdf_converted.split(".")
        : element.file.split(".");
      const type =
        fileNameParts.length > 1 ? fileNameParts[fileNameParts.length - 1] : "";

      if (fileToShow.includes(type)) {
        setDocModalFile({ type, title: element.file, id: element.id });
        setDocModal(true);
      } else {
        try {
          const response = await getAppFileData(element.id);
          if (response.success) {
            const data = response.data;
            const fileNameParts = data.pdf_converted
              ? data.pdf_converted.split(".")
              : data.file.split(".");
            const fileData = {
              type:
                fileNameParts.length > 1
                  ? fileNameParts[fileNameParts.length - 1]
                  : "",
              title: data.file,
              id: data.id,
            };
            setDocModalFile(fileData);
            setDocModal(true);
          } else {
            getAlertPopUp({
              title: "Error!",
              html: response.message,
              error: true,
            });
          }
        } catch (error) {
          getAlertPopUp({ title: "Error!", html: error.message, error: true });
        }
      }
    } else if (element.name && element.path) {
      const filePath = element.path.replaceAll("/", "*");
      setDocModalFile({ type: "pdf", title: element.name, id: filePath });
      setDocModal(true);
    }
  };

  return (
    <div className={style.documents_section}>
      <div className={style.doc_heading}>
        <h5>Documents</h5>
      </div>

      {loading && (
        <div className={style.loading_spinner}>
          <Spinner />
        </div>
      )}

      {!loading && documents.length === 0 && (
        <div className={style.no_documents}>
          <p>No documents uploaded yet.</p>
        </div>
      )}

      {!loading && documents.length > 0 && (
        <div className={style.doc_list}>
          {documents.map((doc, index) => (
            <div className={style.doc_item} key={index} onClick={() => openDocModal(doc)}>
              <PDFIcon />
              <div className={style.doc_info}>
                <span className={style.doc_name}>{doc.title}</span>
                <span className={style.doc_size}>{doc.file}</span>

              </div>
            </div>
          ))}
        </div>
      )}

      <ShowDocsModal
        isOpen={docModal}
        close={() => setDocModal(false)}
        file={docModalFile}
      />
    </div>
  );
}

export default Documents;
